// Photography category step images

import portraitPhotographyCh1S1 from '@/assets/step-images/portrait-photography-ch1-s1.jpg';
import portraitPhotographyCh1S2 from '@/assets/step-images/portrait-photography-ch1-s2.jpg';
import portraitPhotographyCh1S3 from '@/assets/step-images/portrait-photography-ch1-s3.jpg';
import portraitPhotographyCh1S4 from '@/assets/step-images/portrait-photography-ch1-s4.jpg';
import portraitPhotographyCh1S5 from '@/assets/step-images/portrait-photography-ch1-s5.jpg';
import portraitPhotographyCh2S1 from '@/assets/step-images/portrait-photography-ch2-s1.jpg';
import portraitPhotographyCh2S2 from '@/assets/step-images/portrait-photography-ch2-s2.jpg';
import portraitPhotographyCh2S3 from '@/assets/step-images/portrait-photography-ch2-s3.jpg';
import portraitPhotographyCh2S4 from '@/assets/step-images/portrait-photography-ch2-s4.jpg';
import portraitPhotographyCh2S5 from '@/assets/step-images/portrait-photography-ch2-s5.jpg';
import portraitPhotographyCh3S1 from '@/assets/step-images/portrait-photography-ch3-s1.jpg';
import portraitPhotographyCh3S2 from '@/assets/step-images/portrait-photography-ch3-s2.jpg';
import portraitPhotographyCh3S3 from '@/assets/step-images/portrait-photography-ch3-s3.jpg';
import portraitPhotographyCh3S4 from '@/assets/step-images/portrait-photography-ch3-s4.jpg';
import portraitPhotographyCh3S5 from '@/assets/step-images/portrait-photography-ch3-s5.jpg';

import filmPhotographyCh1S1 from '@/assets/step-images/film-photography-ch1-s1.jpg';
import filmPhotographyCh1S2 from '@/assets/step-images/film-photography-ch1-s2.jpg';
import filmPhotographyCh1S3 from '@/assets/step-images/film-photography-ch1-s3.jpg';
import filmPhotographyCh1S4 from '@/assets/step-images/film-photography-ch1-s4.jpg';
import filmPhotographyCh1S5 from '@/assets/step-images/film-photography-ch1-s5.jpg';
import filmPhotographyCh2S1 from '@/assets/step-images/film-photography-ch2-s1.jpg';
import filmPhotographyCh2S2 from '@/assets/step-images/film-photography-ch2-s2.jpg';
import filmPhotographyCh2S3 from '@/assets/step-images/film-photography-ch2-s3.jpg';
import filmPhotographyCh2S4 from '@/assets/step-images/film-photography-ch2-s4.jpg';
import filmPhotographyCh2S5 from '@/assets/step-images/film-photography-ch2-s5.jpg';
import filmPhotographyCh3S1 from '@/assets/step-images/film-photography-ch3-s1.jpg';
import filmPhotographyCh3S2 from '@/assets/step-images/film-photography-ch3-s2.jpg';
import filmPhotographyCh3S3 from '@/assets/step-images/film-photography-ch3-s3.jpg';
import filmPhotographyCh3S4 from '@/assets/step-images/film-photography-ch3-s4.jpg';
import filmPhotographyCh3S5 from '@/assets/step-images/film-photography-ch3-s5.jpg';

import streetPhotographyCh1S1 from '@/assets/step-images/street-photography-ch1-s1.jpg';
import streetPhotographyCh1S2 from '@/assets/step-images/street-photography-ch1-s2.jpg';
import streetPhotographyCh1S3 from '@/assets/step-images/street-photography-ch1-s3.jpg';
import streetPhotographyCh1S4 from '@/assets/step-images/street-photography-ch1-s4.jpg';
import streetPhotographyCh1S5 from '@/assets/step-images/street-photography-ch1-s5.jpg';
import streetPhotographyCh2S1 from '@/assets/step-images/street-photography-ch2-s1.jpg';
import streetPhotographyCh2S2 from '@/assets/step-images/street-photography-ch2-s2.jpg';
import streetPhotographyCh2S3 from '@/assets/step-images/street-photography-ch2-s3.jpg';
import streetPhotographyCh2S4 from '@/assets/step-images/street-photography-ch2-s4.jpg';
import streetPhotographyCh2S5 from '@/assets/step-images/street-photography-ch2-s5.jpg';
import streetPhotographyCh3S1 from '@/assets/step-images/street-photography-ch3-s1.jpg';
import streetPhotographyCh3S2 from '@/assets/step-images/street-photography-ch3-s2.jpg';
import streetPhotographyCh3S3 from '@/assets/step-images/street-photography-ch3-s3.jpg';
import streetPhotographyCh3S4 from '@/assets/step-images/street-photography-ch3-s4.jpg';
import streetPhotographyCh3S5 from '@/assets/step-images/street-photography-ch3-s5.jpg';

import fiveFrameCityStoryCh1S1 from '@/assets/step-images/five-frame-city-story-ch1-s1.jpg';
import fiveFrameCityStoryCh1S2 from '@/assets/step-images/five-frame-city-story-ch1-s2.jpg';
import fiveFrameCityStoryCh1S3 from '@/assets/step-images/five-frame-city-story-ch1-s3.jpg';
import fiveFrameCityStoryCh1S4 from '@/assets/step-images/five-frame-city-story-ch1-s4.jpg';
import fiveFrameCityStoryCh1S5 from '@/assets/step-images/five-frame-city-story-ch1-s5.jpg';
import fiveFrameCityStoryCh2S1 from '@/assets/step-images/five-frame-city-story-ch2-s1.jpg';
import fiveFrameCityStoryCh2S2 from '@/assets/step-images/five-frame-city-story-ch2-s2.jpg';
import fiveFrameCityStoryCh2S3 from '@/assets/step-images/five-frame-city-story-ch2-s3.jpg';
import fiveFrameCityStoryCh2S4 from '@/assets/step-images/five-frame-city-story-ch2-s4.jpg';
import fiveFrameCityStoryCh2S5 from '@/assets/step-images/five-frame-city-story-ch2-s5.jpg';
import fiveFrameCityStoryCh3S1 from '@/assets/step-images/five-frame-city-story-ch3-s1.jpg';
import fiveFrameCityStoryCh3S2 from '@/assets/step-images/five-frame-city-story-ch3-s2.jpg';
import fiveFrameCityStoryCh3S3 from '@/assets/step-images/five-frame-city-story-ch3-s3.jpg';
import fiveFrameCityStoryCh3S4 from '@/assets/step-images/five-frame-city-story-ch3-s4.jpg';
import fiveFrameCityStoryCh3S5 from '@/assets/step-images/five-frame-city-story-ch3-s5.jpg';

import abstractLightStudyCh1S1 from '@/assets/step-images/abstract-light-study-ch1-s1.jpg';
import abstractLightStudyCh1S2 from '@/assets/step-images/abstract-light-study-ch1-s2.jpg';
import abstractLightStudyCh1S3 from '@/assets/step-images/abstract-light-study-ch1-s3.jpg';
import abstractLightStudyCh1S4 from '@/assets/step-images/abstract-light-study-ch1-s4.jpg';
import abstractLightStudyCh1S5 from '@/assets/step-images/abstract-light-study-ch1-s5.jpg';
import abstractLightStudyCh2S1 from '@/assets/step-images/abstract-light-study-ch2-s1.jpg';
import abstractLightStudyCh2S2 from '@/assets/step-images/abstract-light-study-ch2-s2.jpg';
import abstractLightStudyCh2S3 from '@/assets/step-images/abstract-light-study-ch2-s3.jpg';
import abstractLightStudyCh2S4 from '@/assets/step-images/abstract-light-study-ch2-s4.jpg';
import abstractLightStudyCh2S5 from '@/assets/step-images/abstract-light-study-ch2-s5.jpg';
import abstractLightStudyCh3S1 from '@/assets/step-images/abstract-light-study-ch3-s1.jpg';
import abstractLightStudyCh3S2 from '@/assets/step-images/abstract-light-study-ch3-s2.jpg';
import abstractLightStudyCh3S3 from '@/assets/step-images/abstract-light-study-ch3-s3.jpg';
import abstractLightStudyCh3S4 from '@/assets/step-images/abstract-light-study-ch3-s4.jpg';
import abstractLightStudyCh3S5 from '@/assets/step-images/abstract-light-study-ch3-s5.jpg';

import foodPhotoSeriesCh1S1 from '@/assets/step-images/food-photo-series-ch1-s1.jpg';
import foodPhotoSeriesCh1S2 from '@/assets/step-images/food-photo-series-ch1-s2.jpg';
import foodPhotoSeriesCh1S3 from '@/assets/step-images/food-photo-series-ch1-s3.jpg';
import foodPhotoSeriesCh1S4 from '@/assets/step-images/food-photo-series-ch1-s4.jpg';
import foodPhotoSeriesCh1S5 from '@/assets/step-images/food-photo-series-ch1-s5.jpg';
import foodPhotoSeriesCh2S1 from '@/assets/step-images/food-photo-series-ch2-s1.jpg';
import foodPhotoSeriesCh2S2 from '@/assets/step-images/food-photo-series-ch2-s2.jpg';
import foodPhotoSeriesCh2S3 from '@/assets/step-images/food-photo-series-ch2-s3.jpg';
import foodPhotoSeriesCh2S4 from '@/assets/step-images/food-photo-series-ch2-s4.jpg';
import foodPhotoSeriesCh2S5 from '@/assets/step-images/food-photo-series-ch2-s5.jpg';
import foodPhotoSeriesCh3S1 from '@/assets/step-images/food-photo-series-ch3-s1.jpg';
import foodPhotoSeriesCh3S2 from '@/assets/step-images/food-photo-series-ch3-s2.jpg';
import foodPhotoSeriesCh3S3 from '@/assets/step-images/food-photo-series-ch3-s3.jpg';
import foodPhotoSeriesCh3S4 from '@/assets/step-images/food-photo-series-ch3-s4.jpg';
import foodPhotoSeriesCh3S5 from '@/assets/step-images/food-photo-series-ch3-s5.jpg';

import photoZineCh1S1 from '@/assets/step-images/photo-zine-ch1-s1.jpg';
import photoZineCh1S2 from '@/assets/step-images/photo-zine-ch1-s2.jpg';
import photoZineCh1S3 from '@/assets/step-images/photo-zine-ch1-s3.jpg';
import photoZineCh1S4 from '@/assets/step-images/photo-zine-ch1-s4.jpg';
import photoZineCh1S5 from '@/assets/step-images/photo-zine-ch1-s5.jpg';
import photoZineCh2S1 from '@/assets/step-images/photo-zine-ch2-s1.jpg';
import photoZineCh2S2 from '@/assets/step-images/photo-zine-ch2-s2.jpg';
import photoZineCh2S3 from '@/assets/step-images/photo-zine-ch2-s3.jpg';
import photoZineCh2S4 from '@/assets/step-images/photo-zine-ch2-s4.jpg';
import photoZineCh2S5 from '@/assets/step-images/photo-zine-ch2-s5.jpg';
import photoZineCh3S1 from '@/assets/step-images/photo-zine-ch3-s1.jpg';
import photoZineCh3S2 from '@/assets/step-images/photo-zine-ch3-s2.jpg';
import photoZineCh3S3 from '@/assets/step-images/photo-zine-ch3-s3.jpg';
import photoZineCh3S4 from '@/assets/step-images/photo-zine-ch3-s4.jpg';
import photoZineCh3S5 from '@/assets/step-images/photo-zine-ch3-s5.jpg';

import miniNatureZineCh1S1 from '@/assets/step-images/mini-nature-zine-ch1-s1.jpg';
import miniNatureZineCh1S2 from '@/assets/step-images/mini-nature-zine-ch1-s2.jpg';
import miniNatureZineCh1S3 from '@/assets/step-images/mini-nature-zine-ch1-s3.jpg';
import miniNatureZineCh1S4 from '@/assets/step-images/mini-nature-zine-ch1-s4.jpg';
import miniNatureZineCh1S5 from '@/assets/step-images/mini-nature-zine-ch1-s5.jpg';
import miniNatureZineCh2S1 from '@/assets/step-images/mini-nature-zine-ch2-s1.jpg';
import miniNatureZineCh2S2 from '@/assets/step-images/mini-nature-zine-ch2-s2.jpg';
import miniNatureZineCh2S3 from '@/assets/step-images/mini-nature-zine-ch2-s3.jpg';
import miniNatureZineCh2S4 from '@/assets/step-images/mini-nature-zine-ch2-s4.jpg';
import miniNatureZineCh2S5 from '@/assets/step-images/mini-nature-zine-ch2-s5.jpg';
import miniNatureZineCh3S1 from '@/assets/step-images/mini-nature-zine-ch3-s1.jpg';
import miniNatureZineCh3S2 from '@/assets/step-images/mini-nature-zine-ch3-s2.jpg';
import miniNatureZineCh3S3 from '@/assets/step-images/mini-nature-zine-ch3-s3.jpg';
import miniNatureZineCh3S4 from '@/assets/step-images/mini-nature-zine-ch3-s4.jpg';
import miniNatureZineCh3S5 from '@/assets/step-images/mini-nature-zine-ch3-s5.jpg';

import lightShadowSeriesCh1S1 from '@/assets/step-images/light-shadow-series-ch1-s1.jpg';
import lightShadowSeriesCh1S2 from '@/assets/step-images/light-shadow-series-ch1-s2.jpg';
import lightShadowSeriesCh1S3 from '@/assets/step-images/light-shadow-series-ch1-s3.jpg';
import lightShadowSeriesCh1S4 from '@/assets/step-images/light-shadow-series-ch1-s4.jpg';
import lightShadowSeriesCh1S5 from '@/assets/step-images/light-shadow-series-ch1-s5.jpg';
import lightShadowSeriesCh2S1 from '@/assets/step-images/light-shadow-series-ch2-s1.jpg';
import lightShadowSeriesCh2S2 from '@/assets/step-images/light-shadow-series-ch2-s2.jpg';
import lightShadowSeriesCh2S3 from '@/assets/step-images/light-shadow-series-ch2-s3.jpg';
import lightShadowSeriesCh2S4 from '@/assets/step-images/light-shadow-series-ch2-s4.jpg';
import lightShadowSeriesCh2S5 from '@/assets/step-images/light-shadow-series-ch2-s5.jpg';
import lightShadowSeriesCh3S1 from '@/assets/step-images/light-shadow-series-ch3-s1.jpg';
import lightShadowSeriesCh3S2 from '@/assets/step-images/light-shadow-series-ch3-s2.jpg';
import lightShadowSeriesCh3S3 from '@/assets/step-images/light-shadow-series-ch3-s3.jpg';
import lightShadowSeriesCh3S4 from '@/assets/step-images/light-shadow-series-ch3-s4.jpg';
import lightShadowSeriesCh3S5 from '@/assets/step-images/light-shadow-series-ch3-s5.jpg';

export const PHOTOGRAPHY_IMAGES: Record<string, string> = {
  'portrait-photography-ch1-s1': portraitPhotographyCh1S1,
  'portrait-photography-ch1-s2': portraitPhotographyCh1S2,
  'portrait-photography-ch1-s3': portraitPhotographyCh1S3,
  'portrait-photography-ch1-s4': portraitPhotographyCh1S4,
  'portrait-photography-ch1-s5': portraitPhotographyCh1S5,
  'portrait-photography-ch2-s1': portraitPhotographyCh2S1,
  'portrait-photography-ch2-s2': portraitPhotographyCh2S2,
  'portrait-photography-ch2-s3': portraitPhotographyCh2S3,
  'portrait-photography-ch2-s4': portraitPhotographyCh2S4,
  'portrait-photography-ch2-s5': portraitPhotographyCh2S5,
  'portrait-photography-ch3-s1': portraitPhotographyCh3S1,
  'portrait-photography-ch3-s2': portraitPhotographyCh3S2,
  'portrait-photography-ch3-s3': portraitPhotographyCh3S3,
  'portrait-photography-ch3-s4': portraitPhotographyCh3S4,
  'portrait-photography-ch3-s5': portraitPhotographyCh3S5,
  'film-photography-ch1-s1': filmPhotographyCh1S1,
  'film-photography-ch1-s2': filmPhotographyCh1S2,
  'film-photography-ch1-s3': filmPhotographyCh1S3,
  'film-photography-ch1-s4': filmPhotographyCh1S4,
  'film-photography-ch1-s5': filmPhotographyCh1S5,
  'film-photography-ch2-s1': filmPhotographyCh2S1,
  'film-photography-ch2-s2': filmPhotographyCh2S2,
  'film-photography-ch2-s3': filmPhotographyCh2S3,
  'film-photography-ch2-s4': filmPhotographyCh2S4,
  'film-photography-ch2-s5': filmPhotographyCh2S5,
  'film-photography-ch3-s1': filmPhotographyCh3S1,
  'film-photography-ch3-s2': filmPhotographyCh3S2,
  'film-photography-ch3-s3': filmPhotographyCh3S3,
  'film-photography-ch3-s4': filmPhotographyCh3S4,
  'film-photography-ch3-s5': filmPhotographyCh3S5,
  'street-photography-ch1-s1': streetPhotographyCh1S1,
  'street-photography-ch1-s2': streetPhotographyCh1S2,
  'street-photography-ch1-s3': streetPhotographyCh1S3,
  'street-photography-ch1-s4': streetPhotographyCh1S4,
  'street-photography-ch1-s5': streetPhotographyCh1S5,
  'street-photography-ch2-s1': streetPhotographyCh2S1,
  'street-photography-ch2-s2': streetPhotographyCh2S2,
  'street-photography-ch2-s3': streetPhotographyCh2S3,
  'street-photography-ch2-s4': streetPhotographyCh2S4,
  'street-photography-ch2-s5': streetPhotographyCh2S5,
  'street-photography-ch3-s1': streetPhotographyCh3S1,
  'street-photography-ch3-s2': streetPhotographyCh3S2,
  'street-photography-ch3-s3': streetPhotographyCh3S3,
  'street-photography-ch3-s4': streetPhotographyCh3S4,
  'street-photography-ch3-s5': streetPhotographyCh3S5,
  'five-frame-city-story-ch1-s1': fiveFrameCityStoryCh1S1,
  'five-frame-city-story-ch1-s2': fiveFrameCityStoryCh1S2,
  'five-frame-city-story-ch1-s3': fiveFrameCityStoryCh1S3,
  'five-frame-city-story-ch1-s4': fiveFrameCityStoryCh1S4,
  'five-frame-city-story-ch1-s5': fiveFrameCityStoryCh1S5,
  'five-frame-city-story-ch2-s1': fiveFrameCityStoryCh2S1,
  'five-frame-city-story-ch2-s2': fiveFrameCityStoryCh2S2,
  'five-frame-city-story-ch2-s3': fiveFrameCityStoryCh2S3,
  'five-frame-city-story-ch2-s4': fiveFrameCityStoryCh2S4,
  'five-frame-city-story-ch2-s5': fiveFrameCityStoryCh2S5,
  'five-frame-city-story-ch3-s1': fiveFrameCityStoryCh3S1,
  'five-frame-city-story-ch3-s2': fiveFrameCityStoryCh3S2,
  'five-frame-city-story-ch3-s3': fiveFrameCityStoryCh3S3,
  'five-frame-city-story-ch3-s4': fiveFrameCityStoryCh3S4,
  'five-frame-city-story-ch3-s5': fiveFrameCityStoryCh3S5,
  'abstract-light-study-ch1-s1': abstractLightStudyCh1S1,
  'abstract-light-study-ch1-s2': abstractLightStudyCh1S2,
  'abstract-light-study-ch1-s3': abstractLightStudyCh1S3,
  'abstract-light-study-ch1-s4': abstractLightStudyCh1S4,
  'abstract-light-study-ch1-s5': abstractLightStudyCh1S5,
  'abstract-light-study-ch2-s1': abstractLightStudyCh2S1,
  'abstract-light-study-ch2-s2': abstractLightStudyCh2S2,
  'abstract-light-study-ch2-s3': abstractLightStudyCh2S3,
  'abstract-light-study-ch2-s4': abstractLightStudyCh2S4,
  'abstract-light-study-ch2-s5': abstractLightStudyCh2S5,
  'abstract-light-study-ch3-s1': abstractLightStudyCh3S1,
  'abstract-light-study-ch3-s2': abstractLightStudyCh3S2,
  'abstract-light-study-ch3-s3': abstractLightStudyCh3S3,
  'abstract-light-study-ch3-s4': abstractLightStudyCh3S4,
  'abstract-light-study-ch3-s5': abstractLightStudyCh3S5,
  'food-photo-series-ch1-s1': foodPhotoSeriesCh1S1,
  'food-photo-series-ch1-s2': foodPhotoSeriesCh1S2,
  'food-photo-series-ch1-s3': foodPhotoSeriesCh1S3,
  'food-photo-series-ch1-s4': foodPhotoSeriesCh1S4,
  'food-photo-series-ch1-s5': foodPhotoSeriesCh1S5,
  'food-photo-series-ch2-s1': foodPhotoSeriesCh2S1,
  'food-photo-series-ch2-s2': foodPhotoSeriesCh2S2,
  'food-photo-series-ch2-s3': foodPhotoSeriesCh2S3,
  'food-photo-series-ch2-s4': foodPhotoSeriesCh2S4,
  'food-photo-series-ch2-s5': foodPhotoSeriesCh2S5,
  'food-photo-series-ch3-s1': foodPhotoSeriesCh3S1,
  'food-photo-series-ch3-s2': foodPhotoSeriesCh3S2,
  'food-photo-series-ch3-s3': foodPhotoSeriesCh3S3,
  'food-photo-series-ch3-s4': foodPhotoSeriesCh3S4,
  'food-photo-series-ch3-s5': foodPhotoSeriesCh3S5,
  'photo-zine-ch1-s1': photoZineCh1S1,
  'photo-zine-ch1-s2': photoZineCh1S2,
  'photo-zine-ch1-s3': photoZineCh1S3,
  'photo-zine-ch1-s4': photoZineCh1S4,
  'photo-zine-ch1-s5': photoZineCh1S5,
  'photo-zine-ch2-s1': photoZineCh2S1,
  'photo-zine-ch2-s2': photoZineCh2S2,
  'photo-zine-ch2-s3': photoZineCh2S3,
  'photo-zine-ch2-s4': photoZineCh2S4,
  'photo-zine-ch2-s5': photoZineCh2S5,
  'photo-zine-ch3-s1': photoZineCh3S1,
  'photo-zine-ch3-s2': photoZineCh3S2,
  'photo-zine-ch3-s3': photoZineCh3S3,
  'photo-zine-ch3-s4': photoZineCh3S4,
  'photo-zine-ch3-s5': photoZineCh3S5,
  'mini-nature-zine-ch1-s1': miniNatureZineCh1S1,
  'mini-nature-zine-ch1-s2': miniNatureZineCh1S2,
  'mini-nature-zine-ch1-s3': miniNatureZineCh1S3,
  'mini-nature-zine-ch1-s4': miniNatureZineCh1S4,
  'mini-nature-zine-ch1-s5': miniNatureZineCh1S5,
  'mini-nature-zine-ch2-s1': miniNatureZineCh2S1,
  'mini-nature-zine-ch2-s2': miniNatureZineCh2S2,
  'mini-nature-zine-ch2-s3': miniNatureZineCh2S3,
  'mini-nature-zine-ch2-s4': miniNatureZineCh2S4,
  'mini-nature-zine-ch2-s5': miniNatureZineCh2S5,
  'mini-nature-zine-ch3-s1': miniNatureZineCh3S1,
  'mini-nature-zine-ch3-s2': miniNatureZineCh3S2,
  'mini-nature-zine-ch3-s3': miniNatureZineCh3S3,
  'mini-nature-zine-ch3-s4': miniNatureZineCh3S4,
  'mini-nature-zine-ch3-s5': miniNatureZineCh3S5,
  'light-shadow-series-ch1-s2': lightShadowSeriesCh1S2,
  'light-shadow-series-ch1-s3': lightShadowSeriesCh1S3,
  'light-shadow-series-ch1-s4': lightShadowSeriesCh1S4,
  'light-shadow-series-ch1-s5': lightShadowSeriesCh1S5,
  'light-shadow-series-ch2-s1': lightShadowSeriesCh2S1,
  'light-shadow-series-ch2-s2': lightShadowSeriesCh2S2,
  'light-shadow-series-ch2-s3': lightShadowSeriesCh2S3,
  'light-shadow-series-ch2-s4': lightShadowSeriesCh2S4,
  'light-shadow-series-ch2-s5': lightShadowSeriesCh2S5,
  'light-shadow-series-ch3-s1': lightShadowSeriesCh3S1,
  'light-shadow-series-ch3-s2': lightShadowSeriesCh3S2,
  'light-shadow-series-ch3-s3': lightShadowSeriesCh3S3,
  'light-shadow-series-ch3-s4': lightShadowSeriesCh3S4,
  'light-shadow-series-ch3-s5': lightShadowSeriesCh3S5,
};
